//@ts-check

import styled from '@emotion/styled';
import { Avatar, Divider, Radio, Space } from 'antd';
import classnames from 'classnames';
import ImageLoader from 'components/Image';
import { DOMAIN_HOST } from 'config';
import { IMAGE_DIMENSION, USER_ROLES } from 'constants/constants';
import { convertToCapitalize } from 'helpers/formatDataApi';
import {
  ARR_USER_ROLES,
  PREVIOUS_ROLEID,
  SELECTED_CENTRES,
  TEMP_USER_TOKEN,
  USER_TOKEN,
  USER_VIEW_MODE,
} from 'helpers/storage';
import { useTempUserToken, useUser } from 'hooks';
import useI18n from 'hooks/use-i18n';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  MdDarkMode,
  MdDoNotDisturbOnTotalSilence,
  MdLightMode,
  MdOutlineLocalActivity,
  MdOutlineNotifications,
  MdOutlinePowerSettingsNew,
  MdOutlineSettings,
  MdPersonOutline,
} from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Button, UncontrolledTooltip } from 'reactstrap';
//@ts-ignore
import styles from 'styles/Header.module.scss';
import {
  changeViewMode,
  getViewMode,
  logout,
  setShouldDisconnectSocket,
  setTempUserToken,
} from 'store/auth';
import { setSelectedCentre } from 'store/master';
import { getDarkMode, setDarkModePreference } from 'store/settings';
import { fetchLearnerData } from 'store/units';
import { RotateCcw } from 'react-feather';
import { BadgeStatus } from 'components/React-table/commonCellAction';
import { deleteCookie } from 'cookies-next';
const getMetaData = (state) => state.settingAccount.metaData;

const MainProfileContainer = styled.div`
  position: relative;
  gap: 15px;
`;

const mainSetting = [
  {
    label: 'Coupon',
    path: '/homes/addCoupon',
    Icon: MdOutlineLocalActivity,
    access: USER_ROLES.ADMIN,
  },
  {
    label: 'Notification',
    path: '/notification',
    Icon: MdOutlineNotifications,
    access: USER_ROLES.ADMIN,
  },
  {
    label: 'Account Settings',
    path: '/account-settings',
    Icon: MdOutlineSettings,
    access: USER_ROLES.SUPER_ADMIN,
  },
];

let opacityColor = '45';
const NavProfile = () => {
  const [toggle, setToggle] = useState(false);
  const profileRef = useRef();
  const router = useRouter();

  const dispatch = useDispatch();
  const tempUserToken = useTempUserToken();
  const viewMode = useSelector(getViewMode);
  const user = useUser();
  const isDarkMode = useSelector(getDarkMode);
  //color theme
  const metaData = useSelector(getMetaData);

  const userRoleArray = [
    {
      name:
        user?.type?.name === USER_ROLES.SUPER_ADMIN ? 'Super Admin' : 'Admin',
      currentRole: USER_ROLES.ADMIN,
    },
    { name: 'Centre Admin', currentRole: USER_ROLES.CENTRE_ADMIN },
    { name: 'Center BL', currentRole: USER_ROLES.CENTRE_BL },
    { name: 'Instructor', currentRole: USER_ROLES.INSTRUCTOR },
    { name: 'Learner', currentRole: USER_ROLES.LEARNER },
  ];

  function handleChangeMode(mode) {
    dispatch(changeViewMode(mode));
    dispatch(fetchLearnerData());

    if (mode !== viewMode) {
      setToggle(false);
      router.push('/');
    }
  }

  async function handleLogout() {
    sessionStorage.removeItem('breadCrumb');
    dispatch(setSelectedCentre(undefined));
    await SELECTED_CENTRES.delete();
    setToggle(false);
    if (metaData?.cmsHomePage == true) {
      await router.push(`/homeCms`);
    } else {
      await router.push(`/login`);
    }

    await dispatch(setShouldDisconnectSocket());

    dispatch(logout());
    //@ts-ignore
    await USER_TOKEN.delete();
    await USER_VIEW_MODE.delete();
    await ARR_USER_ROLES.delete();
    await TEMP_USER_TOKEN.delete();
  }

  async function backToAdmin() {
    setToggle(false);
    sessionStorage.removeItem('breadCrumb');
    dispatch(setSelectedCentre(undefined));
    await SELECTED_CENTRES.delete();
    await USER_VIEW_MODE.delete();
    await dispatch(setTempUserToken(''));
    PREVIOUS_ROLEID.delete();
    deleteCookie('previousRoleid', { path: '/' });
    window.open(`${DOMAIN_HOST}`, '_self');
  }

  const handleDarkModeToggle = useCallback(() => {
    dispatch(setDarkModePreference(!isDarkMode));
  }, [dispatch, isDarkMode]);

  // style section

  const FloatProfile = useMemo(
    () => styled.div`
      z-index: 500;
      position: absolute;
      overflow: hidden;
      pointer-events: none;
      top: 4.5rem;
      border: 1px solid var(--dark-border-clr, #d3d7e6);
      right: 0.5rem;
      opacity: 0;
      scale: 0.95;
      width: 300px;
      border: 1px solid var(--dark-border-clr, #eaeaea);
      border-radius: 10px;
      background-color: var(--dark-control-bg-clr, white);
      color: var(--dark-text-clr, #505050);
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      transition: scale 100ms ease-in-out, opacity 200ms ease-in-out;
      &[aria-hidden='true'] {
        pointer-events: auto;
        transition: scale 200ms ease-in-out, opacity 100ms ease-in-out;
        opacity: 1;
        scale: 1;
      }
      & .badge-role-type {
        position: absolute;
        top: 0px;
        right: 0px;
        background-color: #7e8398;
        border-radius: 0px 2px 2px 10px;
        padding: 3px 20px;
        color: white;
      }

      & .profile__body_section {
        padding: 15px 25px;
      }

      & .profile__head_section {
        height: 120px;
        background-color: var(--surface-bg-clr, #a8b6c045);
      }

      & .profile__head_avatar {
        position: relative;
        & > .profile__head_image {
          position: absolute;
          top: 5.2rem;
          outline: white solid 3px;
          border-radius: 50%;

          & .font-size * {
            font-size: 30px;
          }
        }

        & > p {
          text-transform: capitalize;
        }
      }

      & .profile__body_others_setting {
        gap: 10px;
        & > div {
          aspect-ratio: 1;
          border-radius: 50%;
          width: 30px;
          background-color: var(--surface-bg-clr, #a8b6c045);
        }
      }

      & .ant-divider {
        border-color: var(--dark-border-clr, rgba(0, 0, 0, 0.06));
      }
    `,
    [],
  );

  const ThemeHover = useMemo(
    () => styled.div`
      &:hover {
        color: var(--theme-clr);
      }
      &:hover > svg {
        color: var(--theme-clr);
      }
      &[aria-checked='true'] * {
        color: var(--theme-clr);
      }
      font-size: 14px;
      color: var(--dark-text-clr, #505050);
    `,
    [],
  );

  const othersSetting = useMemo(
    () => [
      {
        name: isDarkMode ? 'Light Mode' : 'Dark Mode',
        action: handleDarkModeToggle,
        Icon: isDarkMode ? MdLightMode : MdDarkMode,
        active: isDarkMode,
      },
      {
        name: 'Profile',
        action: () => {
          setToggle(false);
          router.push('/profile');
        },
        Icon: MdPersonOutline,
        path: '/profile',
      },
      {
        name: 'Logout',
        action: handleLogout,
        Icon: MdOutlinePowerSettingsNew,
        path: '/login',
      },
    ],
    [handleDarkModeToggle, handleLogout, isDarkMode, router],
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef?.current && !profileRef?.current?.contains(event.target)) {
        setToggle(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <MainProfileContainer
      className="d-flex align-items-center justify-content-md-start justify-content-center"
      ref={profileRef}
    >
      {/* avatar profile */}
      <div
        onClick={() => setToggle(!toggle)}
        className="cursor-pointer"
        title={user?.fullName}
      >
        <AvatarProfile AvatarSize={50} quality={320} />
      </div>
      {tempUserToken ? (
        //@ts-ignore
        <Button.Ripple
          id="btn-back-admin"
          className={classnames(
            'btn-icon ml-05',
            styles['btn-return-main-account'],
          )}
          active
          color="flat-secondary"
          onClick={backToAdmin}
        >
          <RotateCcw size={16} />
          <UncontrolledTooltip placement="bottom" target="btn-back-admin">
            Back to Administrator
          </UncontrolledTooltip>
        </Button.Ripple>
      ) : null}
      {/* main section */}

      <FloatProfile aria-hidden={toggle} className="d-flex flex-column">
        {/* main role tag */}

        <span className="badge-role-type">
          {convertToCapitalize(user?.type?.name)}
        </span>

        {/* top profile */}

        <section className="profile__head_section pt-1">
          <div className="profile__head_avatar d-flex flex-column align-items-center justify-content-center h-100">
            {/* <p className="text-center font-weight-semi-bold mb-2">
              {convertToCapitalize(viewMode)}
            </p> */}

            <section className="profile__head_image">
              <AvatarProfile
                AvatarSize={70}
                quality={320}
                className="font-size"
              />
            </section>
          </div>
        </section>
        <br />
        <br />
        <section className="profile__body_section">
          {/* name and email section */}

          <div className="d-flex flex-column align-items-center">
            <section>
              <h5 className="mb-0">{user?.fullName}</h5>
            </section>

            <section>{user?.email}</section>
          </div>
          {/* demerit points */}
          {viewMode === USER_ROLES.LEARNER ? (
            <section
              className="lesson-label-tittle d-flex justify-content-center align-items-center"
              style={{ gap: '8px', fontWeight: '600' }}
            >
              {user?.demeritPoints ? (
                <div title="Demerit Points">Demerit :</div>
              ) : null}
              <div>{user?.demeritPoints ? user?.demeritPoints : null}</div>
            </section>
          ) : null}
          {/* main settings */}
          <div className="d-flex justify-content-center mt-05 profile__body_others_setting">
            {mainSetting.map(({ label, Icon, path, access }, index) =>
              user?.roles?.length && user?.roles?.includes(access) ? (
                <ThemeHover
                  key={index}
                  title={label}
                  aria-checked={path == router.pathname}
                  className="d-flex justify-content-center align-items-center cursor-pointer"
                  onClick={() => {
                    setToggle(false);
                    router.push(path);
                  }}
                >
                  <Icon size={16} color={'#3d5567'} />
                </ThemeHover>
              ) : null,
            )}
          </div>
          <Divider className="my-1" />
          {user?.roles?.length > 1 ? (
            <>
              {/* change role */}
              <div>
                <Radio.Group value={viewMode} size="small">
                  <Space direction="vertical">
                    {userRoleArray.map(({ name, currentRole }, index) =>
                      Array.isArray(user?.roles) && user?.roles?.length
                        ? user?.roles?.includes(currentRole) && (
                            <Radio
                              key={index}
                              value={currentRole}
                              onClick={() => handleChangeMode(currentRole)}
                            >
                              <ThemeHover
                                onClick={() => handleChangeMode(currentRole)}
                              >
                                {name}
                              </ThemeHover>
                            </Radio>
                          )
                        : null,
                    )}
                  </Space>
                </Radio.Group>
              </div>

              <Divider className="my-1" />
            </>
          ) : null}

          {/* log out and profile */}

          <div className="">
            {othersSetting.map(
              ({ name, action, Icon, path, active }, index) => (
                <ThemeHover
                  onClick={action}
                  key={index}
                  className="cursor-pointer mb-05"
                  as="section"
                  aria-checked={active || path === router.pathname}
                >
                  <Icon size={16} className="mr-05" />
                  <span>{name}</span>
                </ThemeHover>
              ),
            )}
          </div>
        </section>
      </FloatProfile>
    </MainProfileContainer>
  );
};

export default NavProfile;

const AvatarProfile = ({ AvatarSize, quality, className = '' }) => {
  const user = useUser();

  return user.avatar?.[IMAGE_DIMENSION.root] ? (
    <Avatar
      size={AvatarSize}
      src={
        <ImageLoader
          src={user.avatar?.[IMAGE_DIMENSION.root]}
          alt="avatar"
          size={quality}
          objectFit="cover"
          layout={'fill'}
        />
      }
    />
  ) : (
    <Avatar
      size={AvatarSize}
      className={`text-dark font-weight-semi-bold ${className}`}
    >
      {user?.fullName?.slice(0, 1)}
    </Avatar>
  );
};
